import React from 'react';
import { useParams } from 'react-router-dom';

import { Slider } from '../../components';
import { useData, useSleepMode } from '../../hooks';

import ScoreSlide from './ScoreSlide';
import { StyledShadowContainer } from './styled';

let startVol = 0;
let vol = 0.2;
const interval = 300; // 200ms intervalZ

const fadein = (audio: any) => {
  const func = setInterval(() => {
    console.log(startVol);
    if (startVol < 1) {
      startVol += 0.05;
      // eslint-disable-next-line no-param-reassign
      audio.volume = startVol > 1 ? 1 : startVol;
    } else {
      clearInterval(func);
    }
  }, interval);
};

const fadeout = (audio: any) =>
  setInterval(() => {
    // Reduce volume by 0.05 as long as it is above 0
    // This works as long as you start with a multiple of 0.05!
    if (vol > 0) {
      vol -= 0.05;
      // eslint-disable-next-line no-param-reassign
      audio.volume = vol;
    } else {
      // Stop the setInterval when 0 is reached
      clearInterval(fadeout(audio));
    }
  }, interval);

const Score = () => {
  const { setStartTime } = useSleepMode();
  const { scores = [] } = useData();
  const params = useParams();

  React.useEffect(() => setStartTime(Date.now()), []);

  let options = {
    initialSlide: 0,
  };

  const slides = scores.map((score, index) => {
    if (score.id === params.scoreId) {
      options = {
        ...options,
        initialSlide: index,
      };
    }
    return (
      <ScoreSlide
        key={score.id}
        id={score['score-title']}
        index={index}
        score={score}
      />
    );
  });

  return (
    <StyledShadowContainer>
      <Slider options={options} slides={slides} />;
    </StyledShadowContainer>
  );
};

export default Score;
